// File: src/hooks/useIsPWA.ts

import { useState, useEffect } from 'react';

export function useIsPWA() {
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    const checkIsPWA = () => {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      
      // Safely check for iOS-specific property
      const nav = window.navigator as any;
      const isInWebAppiOS = nav.standalone === true;

      setIsPWA(isStandalone || isInWebAppiOS);
    };

    checkIsPWA(); // Initial check

    const mediaQueryList = window.matchMedia('(display-mode: standalone)');
    
    // Use the modern addEventListener method
    mediaQueryList.addEventListener('change', checkIsPWA);

    // Cleanup function to remove the event listener
    return () => mediaQueryList.removeEventListener('change', checkIsPWA);
  }, []);

  return isPWA;
}